import { makesQueries } from 'data/graphql'
import { compose, withState } from 'recompose'

const providesOrganizationAnalytics = query =>
  compose(
    withState('analyticsFetchState', 'setAnalyticsFetchState', {
      loading: true,
      error: false,
      pristine: true,
    }),

    withState('analytics', 'setAnalytics', {}),

    makesQueries({
      query,

      batch: false,

      mapPropsToVariables: ({ period }) => ({ period }),

      getOnQueryFromProps({ setAnalyticsFetchState }) {
        return function() {
          setAnalyticsFetchState({
            loading: true,
            error: null,
            pristine: false,
          })
        }
      },

      getOnResultFromProps({ setAnalyticsFetchState, setAnalytics }) {
        return function onResultFromProps({ result }) {
          setAnalytics(result.data.getOrganizationAnalytics)
          setAnalyticsFetchState({
            loading: false,
            error: null,
            pristine: false,
          })
        }
      },

      getOnErrorFromProps({ setAnalyticsFetchState }) {
        return function onErrorFromProps({ error }) {
          setAnalyticsFetchState({ loading: false, error, pristine: false })
        }
      },
    })
  )

export default providesOrganizationAnalytics
